import React, { Component } from 'react'
import Scanner from "./Scanner";
import {Dialog, DialogActions, DialogContent} from '@material-ui/core'
import Grid from "@material-ui/core/Grid";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

class BarcodeScanner extends Component {
    state = {
        results: [],
    }

    _scan = () => {
        this.setState({ scanning: !this.state.scanning })
    }

    _onDetected = result => {
        this.props.recibirTagScan(result.codeResult.code)
    }


    render() {
        return (
            <Dialog
                open={true}

                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Escanear</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Scanner onDetected={this._onDetected} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" size={"small"} onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default BarcodeScanner